import { useState } from 'react'
import { Flex } from '@components/Flex'
import styled from '@emotion/styled'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { useAtomValue } from 'jotai'

import { SubSidebarItem } from './SubSidebar/SubSidebarItem'
import { A } from './A'
import { DefaultTrigger, TriggerProps } from './DefaultTrigger'
import { Hr, Label } from './Typography'

import { LogoutSmallIcon, SettingsSmallIcon } from '@/assets/icons'
import { colors } from '@/constants'
import { useLogout } from '@/features/Auth/application/useLogout'
import { userAtom } from '@/features/Auth/infrastructure/user'

const ContentWrapper = styled.div`
  padding: 1.25rem;
  color: ${colors.light2};
  background-color: ${colors.darkBlue2};
  box-shadow: 0px 30px 40px 0px #0000004d;
  border: 0.5px solid ${colors.darkBlue4};
  border-radius: 1.25rem;
  z-index: 100;
`

const MenuSubSidebarItem = styled(SubSidebarItem)`
  padding-left: 9px;
  padding-top: 9px;
  padding-bottom: 9px;
  height: 40px;
  border-radius: 10px;
`

export function ProfileMenu({
  trigger = DefaultTrigger,
  containerId = 'profile-menu-trigger',
  align = 'end',
  side = 'bottom',
  sideOffset = 10,
  alignOffset = 0,
}: {
  trigger?: (props: TriggerProps) => JSX.Element
  containerId?: string
  align?: 'end' | 'start' | 'center'
  side?: 'top' | 'right' | 'bottom' | 'left'
  sideOffset?: number
  alignOffset?: number
}) {
  const logout = useLogout()
  const [open, setOpen] = useState(false)
  const user = useAtomValue(userAtom)

  const triggerElement = trigger({ open, setOpen })

  return (
    <DropdownMenu.Root open={open} onOpenChange={setOpen}>
      <DropdownMenu.Trigger>{triggerElement}</DropdownMenu.Trigger>

      <DropdownMenu.Portal container={document.getElementById(containerId)}>
        <DropdownMenu.Content
          sideOffset={sideOffset}
          align={align}
          alignOffset={alignOffset}
          side={side}
        >
          <ContentWrapper>
            <Flex width="225px" gap="20px" flexDirection="column">
              <Flex flexDirection="column" gap="0.1875rem">
                <Label color="white">Profile</Label>
                <Label color="light2">
                  {user.state === 'hasData' && user.data ? user.data.email : 'Loading...'}
                </Label>
              </Flex>
              <Hr />
              <Flex flexDirection="column">
                <MenuSubSidebarItem onClick={() => logout()}>
                  <LogoutSmallIcon />
                  <Label>Log out</Label>
                </MenuSubSidebarItem>
              </Flex>
            </Flex>
          </ContentWrapper>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
